import Lottie from 'lottie-react';
import loading from './LottieJson/loading.json';
const Loading = () => {
  return <Lottie animationData={loading} loop={true} style={{ height: 200 }} />;
};

export default Loading;
